import styles from './ImageBannerSection.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class ImageBannerSection extends CustomComponent {
    constructor() {
        super();
        this.customStyle = styles;
    }

    get backdrop(): string {
        return this.dataset.backdrop ?? 'backdrop-opacity-black-low';
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(`image-banner`, this.backdrop);
        container.innerHTML = `
            <div class="background"></div>
            <div class="body">
                <div class="title"></div>
                <div class="slot"></div>
                <div class="cta">
                    <slot name="cta"></slot>
                </div>
            </div>
      `;
        // Clone Slots into container to prevent styling issues
        this.cloneSlotContentIntoContainer(container.querySelector('.title'), 'title');
        this.cloneSlotContentIntoContainer(container.querySelector('.background'), 'background');
        this.cloneDefaultSlotContentIntoContainer(container.querySelector('.slot'));
        // Remove CTA if not set
        if(!this.querySelector('[slot=cta]')) {
            container.querySelector('.cta').remove();
        }
        return container;
    }

}

customElements.define('nxt-image-banner-section', ImageBannerSection);
